import { render, staticRenderFns } from "./amortization-breakdown-table.vue?vue&type=template&id=2508138b"
import script from "./amortization-breakdown-table.vue?vue&type=script&lang=js"
export * from "./amortization-breakdown-table.vue?vue&type=script&lang=js"
import style0 from "./amortization-breakdown-table.vue?vue&type=style&index=0&id=2508138b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports